import React, { useState } from 'react'
import styles from './email-confirmation-required.styles'
import injectSheet from 'react-jss'
import Wrapper from '../../../../wrapper/wrapper'
import Container from '../../../../container/container'
import duck from '../../../../images/su-duck.gif'
import bear from '../../../../images/su-bear.gif'
import dinosaur from '../../../../images/su-dinosaur.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRedoAlt } from '@fortawesome/pro-solid-svg-icons/faRedoAlt'
import Button from 'pobble-components/dist/button'
import Description from '../../../../description/description'

const accountTypeMap = {
  teacher: {
    containerProps: { primary: true, img: duck }
  },
  user: {
    containerProps: { secondary: true, img: bear }
  },
  notChosen: {
    containerProps: { neutral: true, img: dinosaur }
  }
}

const EmailConfirmationRequired = ({
  accountType,
  classes,
  resentConfirmation
}) => {
  const accountData = !accountType
    ? accountTypeMap.notChosen
    : accountTypeMap[accountType]

  const [emailResent, setEmailResent] = useState(false)
  return (
    <Wrapper>
      <Container {...accountData.containerProps}>
        <Description last title="Nearly there…">
          <p>
            We’ve sent you a confirmation email.
            <br />
            Please click the link in the email to activate your Pobble account.
          </p>
          <p className={classes.hint}>
            You should receive the link within 2 minutes.
            <br />
            If you haven’t received it, you can try to re-send email:
            <br />
          </p>
          {!emailResent && (
            <Button
              action={() => {
                setEmailResent(true)
                resentConfirmation()
              }}
              tall
              simple
              icon={<FontAwesomeIcon icon={faRedoAlt} />}>
              Re-send email
            </Button>
          )}
          {emailResent && (
            <p className={classes.reSentMessage}>Email has been re-sent!</p>
          )}
        </Description>
      </Container>
    </Wrapper>
  )
}

export default injectSheet(styles)(EmailConfirmationRequired)
